module.exports = __webpack_public_path__ + "img/image_30.7c75028f.png";